/* Verolae · Reasons carousel
   Reproduces the inline script of the source site sections `reasons_carousel_ceylon` / `mb_reasons_carousel_5`:
   a Swiper instance on the scroll container (custom wrapper/slide classes, grab cursor, prev/next arrows, clickable
   bullet pagination rendered as <button>s, 1 or 1.3 / 2.3 / 3 slides per view at 0 / 750 / 990 px) plus the CTA
   "smooth scroll to the product form" behaviour. Uses the globally loaded Swiper 11 (window.Swiper, theme.liquid);
   one instance per section, keyed by data-section-id; re-initialised on theme-editor section load. */
(function () {
  'use strict';

  var ROOT_SELECTOR = '.ceylon-reasons-carousel-wrapper[data-section-id]';
  var instances = {};

  function destroy(id) {
    if (instances[id]) {
      instances[id].destroy(true, true);
      delete instances[id];
    }
  }

  function bindCta(root, ctaBtn) {
    if (!ctaBtn || ctaBtn.getAttribute('data-bound')) return;
    ctaBtn.setAttribute('data-bound', '1');
    ctaBtn.addEventListener('click', function (event) {
      if (root.getAttribute('data-cta-scroll') !== 'true') return; // plain link
      var target = document.querySelector('product-info, .product__info-container, .product-form');
      if (target) {
        // Source behaviour: scroll to the purchase area when it is on the page (product template).
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      var href = (ctaBtn.getAttribute('href') || '').trim();
      if (href === '' || href === '#') {
        // Source fallback (its href was "#"): scroll to the top of the page.
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      // Otherwise follow the configured link (no product form on this page).
    });
  }

  function init(root) {
    var id = root.getAttribute('data-section-id');
    if (!id || !window.Swiper) return;

    var container = root.querySelector('.ceylon-reasons-scroll-container');
    var cards = root.querySelectorAll('.ceylon-reasons-card-item');
    var ctaBtn = root.querySelector('.ceylon-reasons-cta-btn-js');

    if (!container || cards.length === 0) return;

    destroy(id);

    var mobileSlides = parseFloat(root.getAttribute('data-mobile-slides'));
    if (!mobileSlides || mobileSlides <= 0) mobileSlides = 1;

    instances[id] = new window.Swiper(container, {
      wrapperClass: 'ceylon-reasons-scroll-row',
      slideClass: 'ceylon-reasons-card-item',
      grabCursor: true,
      navigation: {
        nextEl: root.querySelector('.ceylon-reasons-nav-btn--next'),
        prevEl: root.querySelector('.ceylon-reasons-nav-btn--prev')
      },
      pagination: {
        el: root.querySelector('.ceylon-reasons-dots'),
        clickable: true,
        bulletClass: 'ceylon-reasons-dot',
        bulletActiveClass: 'active',
        renderBullet: function (index, className) {
          return '<button class="' + className + '" aria-label="Go to slide ' + (index + 1) + '"></button>';
        }
      },
      breakpoints: {
        0: {
          slidesPerView: mobileSlides,
          spaceBetween: 16
        },
        750: {
          slidesPerView: 2.3,
          spaceBetween: 20
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 24
        }
      }
    });

    bindCta(root, ctaBtn);
  }

  function whenSwiperReady(callback, tries) {
    if (window.Swiper) { callback(); return; }
    tries = tries || 0;
    if (tries > 100) return; // give up after ~10 s (Swiper is loaded globally in theme.liquid)
    setTimeout(function () { whenSwiperReady(callback, tries + 1); }, 100);
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  function boot() { whenSwiperReady(initAll); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector(ROOT_SELECTOR);
      if (root) whenSwiperReady(function () { init(root); });
    });
    document.addEventListener('shopify:section:unload', function (event) {
      destroy(event.detail.sectionId);
    });
    document.addEventListener('shopify:block:select', function (event) {
      var root = event.target.closest(ROOT_SELECTOR);
      if (!root) return;
      var swiper = instances[root.getAttribute('data-section-id')];
      var index = parseInt(event.target.getAttribute('data-slide-index'), 10);
      if (!swiper || isNaN(index)) return;
      swiper.slideTo(index);
    });
  }
})();
